import { Checkbox, Input } from '@material-ui/core';
import { Done } from '@material-ui/icons';
import { rhythm } from 'Themes/typography';
import React from 'react';
import styled from 'styled-components';

import FieldError from '../components/FieldError';

const Container = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.blue.light};
  border-bottom: 1px solid ${({ theme }) => theme.palette.blue.light};
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${rhythm(0.25)} 0;
  flex: 0 0 100%;
  margin-top: -1px;

  &:last-child {
    border-top: 0;
  }

  &:nth-child(2n) {
    border-top: 0;
  }

  @media screen and (min-width: 41.5625em) {
    flex: 0 0 49%;
    &:first-child,
    &:nth-child(2n) {
      border-top: 1px solid ${({ theme }) => theme.palette.blue.light};
    }
  }
`;

// border-top: 1px solid ${({ theme }) => theme.palette.blue.light};
// border-bottom: 1px solid ${({ theme }) => theme.palette.blue.light};

// &:first-child {
//   border-top: 1px solid ${({ theme }) => theme.palette.blue.light};
// }
const ContainerShortlisted = styled.div`
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  padding: ${rhythm(0.1)} 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 100%;
  // margin-top: -1px;
  &:last-child {
    border-top: 0;
  }
  &:nth-child(2n) {
    border-top: 0;
  }

  @media screen and (min-width: 41.5625em) {
    flex: 0 0 49%;
  }
  &&& > h3 {
    margin-bottom: 0.3rem !important;
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 0.75rem;
  flex: 1;
  position: relative;
`;

const Desc = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.blue.main};
  flex: 2;
`;

const CustomCheckbox = styled(Checkbox)`
  &&& {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

const CheckboxContainer = styled.div`
  text-align: right;
  width: 100%;
  flex: 0.5;
`;

const InputWrapper = styled.div`
  flex: 1.5;
`;

class SettingsItem extends React.PureComponent {
  renderItem = ({
    title,
    desc,
    onChange,
    name,
    criteriaId,
    checked,
    value,
    error,
    handleBlur,
    preview,
    shortlisted,
    inputValue,
  }) => {
    return (
      <React.Fragment>
        <Title>
          <div>{title}:</div>
          {error && <FieldError>{`*${error}`}</FieldError>}
        </Title>
        <Desc>{desc}</Desc>
        {shortlisted === 'change this logic!!!' ? (
          <InputWrapper>
            <Input
              name={`criteriaValues.${criteriaId}`}
              onChange={onChange}
              onBlur={handleBlur}
              fullWidth
              value={inputValue}
            />
          </InputWrapper>
        ) : null}
        <CheckboxContainer>
          {preview ? <Done /> : null}
          {!preview ? (
            <CustomCheckbox
              disableRipple
              checked={checked}
              onChange={onChange}
              onBlur={handleBlur}
              value={value}
              name={name}
            />
          ) : null}
        </CheckboxContainer>
      </React.Fragment>
    );
  };
  render() {
    const { shortlisted } = this.props;
    const props = this.props;
    return (
      <React.Fragment>
        {!shortlisted ? (
          <Container>{this.renderItem(props)}</Container>
        ) : (
          <ContainerShortlisted>{this.renderItem(props)}</ContainerShortlisted>
        )}
      </React.Fragment>
    );
  }
}

export default SettingsItem;
